
import Centrifuge from "centrifuge";
import {
  getSymbolToTokenFromMap,
  getTokenBySymbol,
} from "./helpers.js";

const centrifuge = new Centrifuge(
  process.env.REACT_APP_API_FEED
);

centrifuge.on("connect", function (ctx) {
  // console.log(
  //   "Connected with client ID " + ctx.client + " over " + ctx.transport
  // );
});

centrifuge.on("disconnect", function (ctx) {
  console.log(
    "Disconnected: " +
    ctx.reason +
    (ctx.reconnect ? ", will try to reconnect" : ", won't try to reconnect")
  );
});

centrifuge.connect();

const channelToSubscription = new Map();

function onData(message, extraArg) {
  const {
    token: ticker,
    lp,
    ext,
    v,
    ...data
  } = message.data;




  const subscriptionItem = channelToSubscription.get(`${ticker + '_' + extraArg}`);

  // console.log('ticker',subscriptionItem)

  if (subscriptionItem === undefined) {
    return;
  }

  Object.keys(subscriptionItem.lastBars).forEach((key) => {
    const indicator = key;

    const lastBar = subscriptionItem.lastBars[indicator];
    if (ext < lastBar?.time / 1000) {
      // disregard the initial catchup snapshot of trades for already closed candles
      return;
    }

    let resolution = subscriptionItem.resolution;
    if (resolution.includes("D")) {
      // 1 day in minutes
      resolution = 60 * 24;
    }
    const resolutionSeconds = resolution * 60;

    // every handler is going to handle a different custom indicator
    const lastBarSec = lastBar?.time / 1000;
    const nextBarTime = lastBarSec + resolutionSeconds;

    let toBeUpdatedBar;
    let handler;

    switch (indicator) {
      case "default":
        // check if the current time from message is greater than the next update time based on resolution?
        if (ext >= nextBarTime) {
          // make a new bar if the time is greater
          toBeUpdatedBar = {
            time: ext * 1000,
            open: lastBar?.close,
            high: lp,
            low: lp,
            close: lp,
            volume: v,
          };
        } else {
          // update the current last bar
          toBeUpdatedBar = {
            ...lastBar,
            high: Math.max(lastBar?.high, lp),
            low: Math.min(lastBar?.low, lp),
            close: lp,
            volume: lastBar?.volume + v,
          };
        }
        subscriptionItem.lastBars[indicator] = toBeUpdatedBar;

        //get the handler for the default indicator
        handler = subscriptionItem.handlers.find(
          (h) => h.customIndicator === indicator
        );

        handler?.callback(toBeUpdatedBar);
        break;

      case "oi":
        if (ext >= nextBarTime) {
          // make a new bar if the time is greater
          toBeUpdatedBar = {
            time: ext * 1000,
            close: message.data.oi,
          };
        } else {
          // update the current last bar
          toBeUpdatedBar = {
            ...lastBar,
            close: message.data.oi,
          };
        }
        subscriptionItem.lastBars[indicator] = toBeUpdatedBar;

        //get the handler for the default indicator
        handler = subscriptionItem.handlers.find(
          (h) => h.customIndicator === indicator
        );

        handler?.callback(toBeUpdatedBar);
        break;

      case "d":
        // console.log(
        //   "ld+cd===>",
        //   lastBar.delta,
        //   lastBar.close,
        //   message.data.dv,
        //   (lastBar.delta ? lastBar.delta : 0) + message.data.dv
        // );
        if (ext >= nextBarTime) {
          // make a new bar if the time is greater
          toBeUpdatedBar = {
            time: ext * 1000,
            delta: 0,
            close: 0,
          };
        } else {
          // update the current last bar
          toBeUpdatedBar = {
            ...lastBar,
            delta: (lastBar?.delta ? lastBar?.delta : 0) + message.data.dv,
            close: (lastBar?.delta ? lastBar?.delta : 0) + message.data.dv,
          };
        }
        subscriptionItem.lastBars[indicator] = toBeUpdatedBar;

        //get the handler for the default indicator
        handler = subscriptionItem.handlers.find(
          (h) => h.customIndicator === indicator
        );

        handler?.callback(toBeUpdatedBar);
        break;
      case "cd":
        // console.log(
        //   "cd===>",

        //   message.data.cdv
        // );
        if (ext >= nextBarTime) {
          // make a new bar if the time is greater
          toBeUpdatedBar = {
            time: ext * 1000,
            close: message.data.cdv,
          };
        } else {
          // update the current last bar
          toBeUpdatedBar = {
            ...lastBar,
            close: message.data.cdv,
          };
        }
        subscriptionItem.lastBars[indicator] = toBeUpdatedBar;

        //get the handler for the default indicator
        handler = subscriptionItem.handlers.find(
          (h) => h.customIndicator === indicator
        );

        handler?.callback(toBeUpdatedBar);
        break;
      case "deltabars":
        if (ext >= nextBarTime) {
          // make a new bar if the time is greater
          toBeUpdatedBar = {
            time: ext * 1000,
            open: lastBar?.close,
            high: message.data.cdv,
            low: message.data.cdv,
            close: message.data.cdv,
          };
        } else {
          // update the current last bar
          toBeUpdatedBar = {
            ...lastBar,
            high: Math.max(lastBar?.high, message.data.cdv),
            low: Math.min(lastBar?.low, message.data.cdv),
            close: message.data.cdv,
          };
        }
        subscriptionItem.lastBars[indicator] = toBeUpdatedBar;

        //get the handler for the default indicator
        handler = subscriptionItem.handlers.find(
          (h) => h.customIndicator === indicator
        );

        handler?.callback(toBeUpdatedBar);
        break;

      case "FTIVBars":
        if (ext >= nextBarTime) {
          // make a new bar if the time is greater
          toBeUpdatedBar = {
            time: ext * 1000,
            open: lastBar?.close,
            high: message.data.iv,
            low: message.data.iv,
            close: message.data.iv,
          };
        } else {
          // update the current last bar
          toBeUpdatedBar = {
            ...lastBar,
            high: Math.max(lastBar?.high, message.data.iv),
            low: Math.min(lastBar?.low, message.data.iv),
            close: message.data.iv,
          };
        }
        subscriptionItem.lastBars[indicator] = toBeUpdatedBar;

        //get the handler for the default indicator
        handler = subscriptionItem.handlers.find(
          (h) => h.customIndicator === indicator
        );

        handler?.callback(toBeUpdatedBar);
        break;
      case "FTGreeksGammaBars":
        // console.log(
        //   "cd===>",

        //   message.data.cdv
        // );
        if (ext >= nextBarTime) {
          // make a new bar if the time is greater
          toBeUpdatedBar = {
            time: ext * 1000,
            close: message.data.g,
          };
        } else {
          // update the current last bar
          toBeUpdatedBar = {
            ...lastBar,
            close: message.data.g,
          };
        }
        subscriptionItem.lastBars[indicator] = toBeUpdatedBar;

        //get the handler for the default indicator
        handler = subscriptionItem.handlers.find(
          (h) => h.customIndicator === indicator
        );

        handler?.callback(toBeUpdatedBar);
        break;
      case "FTGreeksDeltaBars":
        // console.log(
        //   "cd===>",

        //   message.data.cdv
        // );
        if (ext >= nextBarTime) {
          // make a new bar if the time is greater
          toBeUpdatedBar = {
            time: ext * 1000,
            close: message.data.d,
          };
        } else {
          // update the current last bar
          toBeUpdatedBar = {
            ...lastBar,
            close: message.data.d,
          };
        }
        subscriptionItem.lastBars[indicator] = toBeUpdatedBar;

        //get the handler for the default indicator
        handler = subscriptionItem.handlers.find(
          (h) => h.customIndicator === indicator
        );

        handler?.callback(toBeUpdatedBar);
        break;


      case "FTGreeksVegaBars":
        // console.log(
        //   "cd===>",

        //   message.data.cdv
        // );
        if (ext >= nextBarTime) {
          // make a new bar if the time is greater
          toBeUpdatedBar = {
            time: ext * 1000,
            close: message.data.ve,
          };
        } else {
          // update the current last bar
          toBeUpdatedBar = {
            ...lastBar,
            close: message.data.ve,
          };
        }
        subscriptionItem.lastBars[indicator] = toBeUpdatedBar;

        //get the handler for the default indicator
        handler = subscriptionItem.handlers.find(
          (h) => h.customIndicator === indicator
        );

        handler?.callback(toBeUpdatedBar);
        break;
    }
  });
}

export function subscribeOnStream(
  symbolInfo,
  resolution,
  onRealtimeCallback,
  subscriberUID,
  onResetCacheNeededCallback,
  lastBar
) {
  console.log("subscribeOnStream-stream 1 :::::: symbolInfo");


  const theTicker = symbolInfo.ticker.split("#")[0];
  const theCustomIndicator = symbolInfo.ticker.split("#")[1] || "default";
  const token = getSymbolToTokenFromMap(theTicker);
  const channelString = token;
  const handler = {
    customIndicator: theCustomIndicator,
    ticker: symbolInfo.ticker,
    id: subscriberUID,
    callback: onRealtimeCallback,
  };
  let subscriptionItem = channelToSubscription.get(channelString + '_' + resolution);
  if (subscriptionItem && subscriptionItem.resolution === resolution) {
    // already subscribed to the channel, use the existing subscription
    subscriptionItem.lastBars = {
      ...subscriptionItem.lastBars,
      [theCustomIndicator]: lastBar,
    };

    subscriptionItem.handlers.push(handler);
    return;
  }


  subscriptionItem = {
    subscriberUID,
    resolution,
    lastBars: {
      ...subscriptionItem?.lastBars,
      [theCustomIndicator]: lastBar,
    },
    handlers: [handler],
  };

  const subscription = centrifuge.subscribe(channelString, (message) => onData(message, resolution));

  subscriptionItem.subscription = subscription;
  channelToSubscription.set(channelString + '_' + resolution, subscriptionItem);
}

export function unsubscribeFromStream(subscriberUID) {
  // console.log("subscriberUID", channelToSubscription.keys());
  // find a subscription with id === subscriberUID
  // var list_of_subs = [];

  // var current_channel = '';
  // var channel_removed = false;
  // for (const channelString of channelToSubscription.keys()) {


  //   if (current_channel) {
  //     if (current_channel === channelToSubscription.get(channelString).subscription.channel) {


  //     } else {
  //       //unsubscribe from the channel loigc
  //       channel_removed = true;
  //     }
  //   } else {
  //     current_channel = channelToSubscription.get(channelString).subscription.channel;
  //   }
  // }


  // console.log("channel_removed", channel_removed)


  // for (const channelString of channelToSubscription.keys()) {

  //   const subscriptionItem = channelToSubscription.get(channelString);
  //   const handlerIndex = subscriptionItem.handlers.findIndex(
  //     (handler) => handler.id === subscriberUID
  //   );

  //   if (handlerIndex !== -1) {
  //     // remove from handlers
  //     subscriptionItem.handlers.splice(handlerIndex, 1);

  //     if (subscriptionItem.handlers.length === 0) {
  //       // unsubscribe from the channel, if it was the last handler
  //       console.log(
  //         "[unsubscribeBars]: Unsubscribe from streaming. Channel:",
  //         channelString
  //       );
        
  //       if (channel_removed) {
  //         subscriptionItem.subscription.unsubscribe();
  //       }
  //       channelToSubscription.delete(channelString);
  //       break;
  //     }
  //   }
  // }

  
    let currentChannel = '';
    let channelRemoved = false;
  
    for (const [channelString, subscriptionItem] of channelToSubscription) {
      const channel = subscriptionItem.subscription.channel;
  
      if (currentChannel && currentChannel !== channel) {
        channelRemoved = true;
      } else {
        currentChannel = channel;
      }
    }

    console.log("channel_removed", channelRemoved)
  
    for (const [channelString, subscriptionItem] of channelToSubscription) {
      const handlers = subscriptionItem.handlers;
      const handlerIndex = handlers.findIndex(handler => handler.id === subscriberUID);
  
      if (handlerIndex !== -1) {
        handlers.splice(handlerIndex, 1);
  
        if (handlers.length === 0) {
          // console.log("[unsubscribeBars]: Unsubscribe from streaming. Channel:", channelString);
          if (channelRemoved) {
            subscriptionItem.subscription.unsubscribe();
            console.log("[unsubscribeBars]: Unsubscribe from streaming. Channel:", subscriptionItem.subscription.channel);
          }
          channelToSubscription.delete(channelString);
          break;
        }
      }
    }
  



}